import React from "react";

const NumberKey = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.35476 4.76497C2.70745 5.49332 3.29641 6.08076 4.02566 6.43159C4.07945 6.45706 4.13895 6.46808 4.1983 6.46358C4.25764 6.45907 4.31479 6.43919 4.36412 6.40588L5.43521 5.6904C5.48253 5.6583 5.53722 5.63871 5.59416 5.63347C5.65109 5.62823 5.70843 5.63749 5.76082 5.6604L7.7659 6.52156C7.83443 6.55008 7.89168 6.60034 7.92884 6.6646C7.966 6.72885 7.98101 6.80354 7.97155 6.87716C7.908 7.37318 7.66589 7.82905 7.29053 8.15946C6.91517 8.48987 6.43227 8.6722 5.9322 8.67231C4.38685 8.67231 2.9048 8.05842 1.81208 6.9657C0.719355 5.87298 0.105469 4.39093 0.105469 2.84558C0.105581 2.34551 0.287903 1.86261 0.618318 1.48725C0.948732 1.11188 1.4046 0.869776 1.90062 0.806226C1.97424 0.796769 2.04893 0.811775 2.11318 0.848935C2.17744 0.886095 2.2277 0.943347 2.25622 1.01187L3.11737 3.02124C3.13977 3.0728 3.14914 3.12908 3.14465 3.18511C3.14017 3.24115 3.12197 3.29522 3.09167 3.34257L2.37618 4.43079C2.34433 4.48001 2.32563 4.53658 2.32188 4.59509C2.31813 4.6536 2.32945 4.71209 2.35476 4.76497V4.76497Z"
        fill="#AEB9E1"
      />
    </svg>
  );
};

export default NumberKey;
